import React from 'react';
import { Provider } from 'react-redux';
import store from '../state/store';
import Auth from './Auth';

const LoadStore = () => {
  return (
    <Provider store={store}>
        <Auth />
    </Provider>
  );
};

export default LoadStore;